import { createSelector } from "reselect";
import { selectVariablesUser } from "../../../utils/global-selectors";

export const selectTableHeader = (state) => state.cashbackPage?.cabe;
export const selectTableData = (state) => state.cashbackPage?.corpo;
export const selectModal = (state) => state.cashbackPage?.modal;

export const selectIsAdminVoucher = createSelector(
  selectVariablesUser,
  (variables) => variables?.includes("ADMIN_VOUCHER")
);
